import React, { useState } from 'react';
import jollof from './assets/jollof.jpg';

const App = () => {
  const [cartCount, setCartCount] = useState(0);

  const products = [
    {
      id: 1,
      name: 'Jollof Rice Special',
      price: 2500,
      originalPrice: 3000,
      image: jollof,
      rating: 4.9,
      reviews: 324,
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Grilled Chicken & Rice',
      price: 3200,
      originalPrice: 3800,
      image: 'https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 256,
      badge: 'Premium'
    },
    {
      id: 3,
      name: 'Fried Rice Combo',
      price: 2800,
      originalPrice: 3200,
      image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      reviews: 189,
      badge: 'Popular'
    },
    {
      id: 4,
      name: 'Pepper Soup & Swallow',
      price: 3500,
      originalPrice: 4000,
      image: 'https://images.unsplash.com/photo-1547592180-85f173990554?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 178,
      badge: 'Premium'
    },
    {
      id: 5,
      name: 'Beef Stew & Plantain',
      price: 2200,
      originalPrice: 2800,
      image: 'https://images.unsplash.com/photo-1574484284002-952d92456975?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.6,
      reviews: 127,
      badge: 'Popular'
    },
    {
      id: 6,
      name: 'Fish & Chips Special',
      price: 3000,
      originalPrice: 3500,
      image: 'https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      reviews: 203,
      badge: 'New'
    },
    {
      id: 7,
      name: 'Chicken Shawarma',
      price: 1800,
      originalPrice: 2200,
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 289,
      badge: 'Popular'
    },
    {
      id: 8,
      name: 'Meat Pie & Drink',
      price: 1500,
      originalPrice: 1800,
      image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.5,
      reviews: 142,
      badge: 'Sale'
    }
  ];

  const addToCart = () => {
    setCartCount(cartCount + 1);
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white font-poppins">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-lg shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-montserrat font-black text-primary-500 tracking-tight">THE CHOPS BOX</h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Home</button>
                <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Menu</button>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Gallery</button>
                <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Contact</button>
                <button onClick={() => scrollToSection('contact')} className="btn-primary">Order Now</button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="min-h-screen bg-gradient-to-br from-primary-500 via-orange-500 to-yellow-400 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-white/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
            <div className="text-white">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6">
                🍽️ Port Harcourt's #1 Food Destination
              </div>
              <h1 className="text-5xl lg:text-7xl font-montserrat font-black leading-tight mb-6 tracking-tight">
                Delicious Meals with Exceptional Service
              </h1>
              <p className="text-xl lg:text-2xl mb-8 opacity-95 leading-relaxed max-w-2xl">
                Experience the finest Nigerian cuisine prepared with the highest standards of food safety and customer service. Your satisfaction is our priority.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => scrollToSection('products')} className="bg-white text-primary-500 px-8 py-4 rounded-full text-lg font-bold hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 text-center">
                  Order Now <i className="fas fa-arrow-right ml-2"></i>
                </button>
                <button onClick={() => scrollToSection('gallery')} className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white hover:text-primary-500 transition-all duration-300 text-center">
                  View Menu
                </button>
              </div>
            </div>
            <div className="relative">
              <img src={jollof} alt="Delicious Nigerian Food" className="rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500" />
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl">
                <div className="flex items-center space-x-3">
                  <i className="fas fa-shipping-fast text-primary-500 text-2xl"></i>
                  <div>
                    <p className="font-semibold text-gray-800">Fast Delivery</p>
                    <p className="text-sm text-gray-600">Orders over ₦5,000</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Banner */}
      <section className="bg-gradient-to-r from-primary-500 to-orange-500 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-12">
            <h2 className="text-3xl font-montserrat font-bold mb-4">Why Customers Love THE CHOPS BOX</h2>
            <p className="text-xl opacity-90">Port Harcourt's most trusted food destination</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center text-white">
              <i className="fas fa-shipping-fast text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Fast Delivery</h3>
              <p className="opacity-90">Quick delivery service</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-shield-check text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Food Safety</h3>
              <p className="opacity-90">Highest hygiene standards</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-heart text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Customer Service</h3>
              <p className="opacity-90">Exceptional service always</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-utensils text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Fresh Meals</h3>
              <p className="opacity-90">Prepared fresh daily</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Popular Menu</h2>
            <p className="text-xl text-gray-600">Carefully crafted by our expert chefs</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div key={product.id} className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 overflow-hidden group">
                <div className="relative">
                  <img src={product.image} alt={product.name} className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-sm font-semibold text-white ${
                    product.badge === 'Best Seller' ? 'bg-primary-500' :
                    product.badge === 'Premium' ? 'bg-purple-600' :
                    product.badge === 'New' ? 'bg-green-600' :
                    product.badge === 'Popular' ? 'bg-blue-600' :
                    product.badge === 'Sale' ? 'bg-red-600' : 'bg-gray-600'
                  }`}>
                    {product.badge}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="text-yellow-400">
                      {'★'.repeat(Math.floor(product.rating))}{'☆'.repeat(5 - Math.floor(product.rating))}
                    </div>
                    <span className="text-gray-600 ml-2">({product.reviews} reviews)</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <span className="text-2xl font-bold text-primary-500">₦{product.price}</span>
                      {product.originalPrice && (
                        <span className="text-gray-500 line-through">₦{product.originalPrice}</span>
                      )}
                    </div>
                    {product.originalPrice && (
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm font-semibold">
                        {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                      </span>
                    )}
                  </div>
                  <button onClick={() => scrollToSection('contact')} className="w-full btn-primary">
                    Order Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Food Gallery</h2>
            <p className="text-xl text-gray-600">See our delicious meals and happy customers</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-2 lg:row-span-2">
              <img src="https://images.unsplash.com/photo-1586201375761-83865001e31c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Jollof Rice Special" className="w-full h-full object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Grilled Chicken" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Chicken Shawarma" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1603133872878-684f208fb84b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Fried Rice" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1574484284002-952d92456975?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Beef Stew" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gradient-to-r from-primary-500 to-orange-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-montserrat font-bold mb-6">THE CHOPS BOX - Your Food Safety Partner</h2>
              <p className="text-xl mb-8 opacity-95 leading-relaxed">
                A food brand that is focused on customer service and food safety. We prepare every meal with the highest standards of hygiene and quality, ensuring your satisfaction with every bite.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">5K+</h3>
                  <p className="opacity-90">Happy Customers</p>
                </div>
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">50+</h3>
                  <p className="opacity-90">Delicious Meals</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Restaurant Kitchen" className="w-full h-40 object-cover rounded-2xl shadow-lg" />
                <img src="https://images.unsplash.com/photo-1577219491135-ce391730fb2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Chef preparing food" className="w-full h-32 object-cover rounded-2xl shadow-lg" />
              </div>
              <div className="pt-8">
                <img src="https://images.unsplash.com/photo-1586201375761-83865001e31c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Delicious Nigerian food" className="w-full h-48 object-cover rounded-2xl shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-transparent to-orange-500/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-white mb-4">Visit Our Restaurant</h2>
            <p className="text-xl text-gray-300">Experience our delicious meals and exceptional service</p>
          </div>
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-map-marker-alt text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Visit Our Restaurant</h3>
              <p className="text-gray-300 leading-relaxed">
                Road 1 Radio Estate<br />
                Ozuoba<br />
                Port Harcourt, Nigeria
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-phone text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Call Us</h3>
              <p className="text-gray-300 leading-relaxed">
                08132757597<br />
                Mon-Sun: 8AM-10PM
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-utensils text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Order Online</h3>
              <p className="text-gray-300 leading-relaxed">
                Fast delivery service<br />
                Available 24/7
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-400">&copy; 2024 THE CHOPS BOX. All rights reserved.</p>
            </div>
            <div className="flex space-x-6">
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;